import { contactNumber, facebookLink, whatsappNumber } from '../constants';
export const PhoneData = () => {
  return (
    <div className="hidden md:flex space-x-4 items-center justify-end">
      <div className="flex space-x-4">
        <a
          className="h-10 min-w-10 bg-lightRed rounded-full flex justify-center items-center"
          href={facebookLink}
        >
          <img
            src="/health/images/facebook.svg"
            className="size-6 relative -top-1"
            alt="facebook icon"
          />
        </a>
        <a
          href={`https://wa.me/${whatsappNumber}`}
          className="h-10 min-w-10 bg-lightRed rounded-full flex justify-center items-center"
        >
          <img
            src="/health/images/whatsapp.svg"
            className="w-5 h-5"
            alt="whatsapp icon"
          />
        </a>
      </div>
      <div className="text-4.5 lg:block hidden font-medium font-halyard leading-7 cursor-pointer tracking-normal ">
        {contactNumber}
      </div>
    </div>
  );
};
